var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.9509 6C17.0813 6 6.64844 16.272 6.64844 28.9431H53.2533C53.2533 16.272 42.8205 6 29.9509 6Z",
    fill: "#C2D5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.9506 8.78052C18.6409 8.78052 9.47266 17.8074 9.47266 28.9426H50.4285C50.4285 17.8074 41.2602 8.78052 29.9506 8.78052Z",
    fill: "#C2D5F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M29.9526 11.9089C20.398 11.9089 12.6523 19.5351 12.6523 28.9424H47.253C47.253 19.5351 39.5073 11.9089 29.9526 11.9089Z",
    fill: "#C2D5F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6603 27.5092C38.3295 22.7273 34.7495 19.0689 29.8993 19.3856C25.049 19.7024 20.7636 23.876 21.0943 28.6564C21.0943 28.6564 21.3609 38.3702 30.1238 45.8971C30.8449 46.4223 32.1392 46.2999 32.6437 45.7326C40.291 37.1354 38.6618 27.5091 38.6618 27.5091L38.6603 27.5092ZM30.2535 33.5203C27.2061 33.7193 24.5681 31.4452 24.3604 28.4431C24.1527 25.441 26.4552 22.8442 29.5011 22.6453C32.547 22.4464 35.1865 24.7204 35.3942 27.7225C35.6019 30.7246 33.2994 33.3214 30.2535 33.5203Z",
    fill: "#B9551D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6611 27.3759C39.3306 22.5982 35.1375 18.9832 30.2967 19.2994C25.4558 19.6155 21.7985 23.7447 22.129 28.5209C22.129 28.5209 22.3957 38.2262 31.1423 45.7471C31.7193 46.2434 32.5999 46.1859 33.1034 45.6191C40.7353 37.03 39.6627 27.3758 39.6627 27.3758L39.6611 27.3759ZM31.2709 33.3812C28.2294 33.5798 25.5963 31.3075 25.3888 28.308C25.1813 25.3085 27.4791 22.7142 30.5192 22.5156C33.5592 22.3171 36.1938 24.5893 36.4013 27.5888C36.6088 30.5883 34.311 33.1826 31.2709 33.3812Z",
    fill: "#FFB389"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3099 33.8158C34.5565 33.6038 37.0087 30.8356 36.7871 27.6329C36.5655 24.4302 33.7539 22.0057 30.5074 22.2177C27.2608 22.4297 24.8086 25.1979 25.0302 28.4006C25.2518 31.6033 28.0633 34.0278 31.3099 33.8158Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1352 28.1956C29.415 28.1774 29.6148 27.7716 29.5814 27.2893C29.548 26.807 29.2942 26.4308 29.0144 26.4491C28.7346 26.4674 28.5349 26.8732 28.5682 27.3555C28.6016 27.8378 28.8554 28.2139 29.1352 28.1956Z",
    fill: "#B9551D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6821 27.9603C32.9619 27.942 33.1616 27.5362 33.1283 27.0539C33.0949 26.5716 32.841 26.1955 32.5613 26.2137C32.2815 26.232 32.0817 26.6378 32.1151 27.1201C32.1485 27.6024 32.4023 27.9786 32.6821 27.9603Z",
    fill: "#B9551D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1378 25.679C32.8543 25.4404 32.3052 25.2191 31.9132 25.7273",
    stroke: "#B9551D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 25.992C28.6481 25.7186 29.1619 25.4278 29.6202 25.8804",
    stroke: "#B9551D",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7861 30.0895C21.3501 24.8527 16.5734 21.5554 11.2821 22.9409C5.99081 24.3265 2.18707 29.8722 3.62261 35.1075C3.62261 35.1075 6.09132 45.8319 17.4638 52.318C18.3786 52.7471 19.7821 52.3354 20.2129 51.5981C26.7433 40.426 22.7878 30.0891 22.7878 30.0891L22.7861 30.0895ZM14.8372 38.5534C11.5126 39.4239 8.08725 37.4622 7.18574 34.1745C6.28422 30.8868 8.24858 27.5138 11.5715 26.6437C14.8944 25.7736 18.3215 27.7348 19.223 31.0225C20.1245 34.3103 18.1601 37.6833 14.8372 38.5534Z",
    fill: "#0F5936"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8641 29.7262C22.4294 24.4939 16.9846 21.3755 11.7035 22.7584C6.42241 24.1412 3.30323 29.5038 4.73751 34.7344C4.73751 34.7344 7.20452 45.4494 18.5576 51.9322C19.3066 52.36 20.2672 52.1085 20.697 51.372C27.2123 40.2121 23.8657 29.7257 23.8657 29.7257L23.8641 29.7262ZM15.9322 38.1799C12.614 39.0488 9.19449 37.0881 8.29377 33.8032C7.39305 30.5184 9.35285 27.1491 12.6694 26.2807C15.9859 25.4122 19.4071 27.3725 20.3078 30.6574C21.2085 33.9422 19.2487 37.3115 15.9322 38.1799Z",
    fill: "#528BE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0823 38.6651C19.6263 37.7373 21.719 34.1404 20.7565 30.6311C19.794 27.1218 16.1407 25.0291 12.5967 25.9569C9.05268 26.8846 6.95996 30.4815 7.92247 33.9908C8.88498 37.5001 12.5382 39.5928 16.0823 38.6651Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4128 32.8923C12.718 32.8124 12.848 32.3195 12.7032 31.7913C12.5584 31.2632 12.1937 30.8999 11.8885 30.9798C11.5833 31.0597 11.4533 31.5526 11.5981 32.0808C11.7429 32.6089 12.1077 32.9722 12.4128 32.8923Z",
    fill: "#0F5936"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2956 31.8688C16.6008 31.7889 16.7308 31.296 16.586 30.7679C16.4412 30.2398 16.0765 29.8764 15.7713 29.9564C15.4661 30.0363 15.3361 30.5292 15.4809 31.0573C15.6257 31.5854 15.9905 31.9488 16.2956 31.8688Z",
    fill: "#0F5936"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2823 29.2434C15.9149 29.0385 15.2571 28.9099 14.9367 29.5592",
    stroke: "#0F5936",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1023 30.6082C11.3158 30.2509 11.8198 29.8175 12.4289 30.223",
    stroke: "#0F5936",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2626 35.6507C56.7885 31.0887 54.8789 26.3846 50.2717 24.909C45.6645 23.4333 40.1021 25.7457 38.5767 30.3063C38.5767 30.3063 35.1021 39.4253 40.3232 49.6136C40.789 50.3645 42.033 50.7231 42.7169 50.3803C53.0831 45.1861 55.2641 35.6512 55.2641 35.6512L55.2626 35.6507ZM45.1846 38.1659C42.2898 37.2387 40.7212 34.164 41.6792 31.3C42.6371 28.436 45.7615 26.8644 48.6548 27.7911C51.5481 28.7178 53.1181 31.793 52.1602 34.657C51.2022 37.521 48.0779 39.0926 45.1846 38.1659Z",
    fill: "#0A429A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2368 35.8956C57.7613 31.3377 55.2681 26.4502 50.6698 24.9774C46.0714 23.5045 41.1071 26.005 39.5831 30.5615C39.5831 30.5615 36.1119 39.6727 41.3202 49.8494C41.6638 50.5209 42.5002 50.7888 43.183 50.4461C53.532 45.2539 56.2382 35.8961 56.2382 35.8961L56.2368 35.8956ZM46.1764 38.4114C43.2872 37.486 41.7224 34.4148 42.6795 31.5533C43.6366 28.6918 46.7558 27.1208 49.6435 28.0457C52.5312 28.9706 54.0974 32.0424 53.1403 34.9038C52.1832 37.7653 49.0641 39.3363 46.1764 38.4114Z",
    fill: "#2AC682"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0321 38.8391C49.118 39.8273 52.4487 38.1501 53.4715 35.0929C54.4943 32.0358 52.8218 28.7564 49.7359 27.7683C46.65 26.7801 43.3193 28.4573 42.2965 31.5144C41.2737 34.5716 42.9462 37.851 46.0321 38.8391Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1701 32.8159C46.4358 32.9011 46.7759 32.5971 46.9298 32.1371C47.0836 31.677 46.9929 31.2351 46.7272 31.15C46.4615 31.0649 46.1214 31.3688 45.9675 31.8288C45.8137 32.2889 45.9043 32.7308 46.1701 32.8159Z",
    fill: "#0A429A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.549 33.9048C49.8147 33.9899 50.1548 33.686 50.3087 33.2259C50.4625 32.7659 50.3718 32.324 50.1061 32.2388C49.8404 32.1537 49.5003 32.4577 49.3464 32.9177C49.1926 33.3778 49.2832 33.8197 49.549 33.9048Z",
    fill: "#0A429A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8328 31.9525C50.6616 31.6265 50.2374 31.2194 49.6793 31.549",
    stroke: "#0A429A",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3182 30.5001C46.6529 30.3365 47.2405 30.2539 47.4918 30.8432",
    stroke: "#0A429A",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.7ea8647dc2ac4c8f1a945be410cd2827.svg";
export { ForwardRef as ReactComponent };